import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/noticias',
		component: Base,
		children: [
			{
				path: '',
				name: 'NoticiasList',
				component: List,
				meta: {
					path: '/site/noticias',
					pai: 'Site',
					title: 'Admin - Notícias',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Notícias',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'NoticiasNovo',
				component: Form,
				meta: {
					path: '/site/noticias',
					pai: 'Site',
					title: 'Admin - Notícias - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Notícias',
						class: '',
						active: false,
						url: '/site/noticias'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'NoticiasEditar',
				component: Form,
				meta: {
					path: '/site/noticias',
					pai: 'Site',
					title: 'Admin - Notícias - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Notícias',
						class: '',
						active: false,
						url: '/site/noticias'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]